// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Image Styling */
.ContactFirst-image {
  width: 100%;
  height: auto;
  animation: fadeIn 1.5s ease-in-out;
}

/* Container Background Styling */
.contactpage-container {
  background-image: url("https://img.freepik.com/premium-vector/light-yellow-background-with-light-orange-background_851674-48.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  font-family: 'Times New Roman', Times, serif;
}

.animate-title {
  color: rgb(11, 16, 76);
  font-size: 2rem;
  font-family: 'Times New Roman', Times, serif;
}

.second-column {
  padding: 20px;
}

/* Address Section */
.addressPage {
  background-color: rgba(246, 208, 190, 0.345);
 height: 570px;
  width: 660px;
  margin-top: 2%;


}



.addresscontent {
  font-size: 1.2rem;
  padding: 30px;
  color: rgb(0, 0, 0);
  font-weight: 800;
  margin-top: 30px;

}

.contact-paratag {
  margin-bottom: 10px;
max-width:250px;
display: flex;
justify-content:space-around;
}
.contact-paratag a {
  color: #530702; 
  text-decoration: none; 
  width: 150px;

}
.addresscontent a {
  color: #530702; 
  text-decoration: none; 

}









.addressinfo {
  text-align: center;
  color: rgb(0, 0, 0);
}
.form-page{
padding: 5px;
}
/* Form Styling */
.form-group {

  font-size: 1rem;
}

.form-control {

  border-radius: 8px;
  margin-top: -10px;

  /* padding: 10px; */
}

.btn-primary {
  background-color: #0e055e;
  font-size: 1.1rem;
  transition: background-color 0.3s ease-in-out;
}

.btn-primary:hover {
  background-color: #ff7b00;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-title {
  animation: slideDown 1.5s ease-in-out;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .addressPage {
    height: auto;
    width: 90%;
    margin: 20px auto;
    padding: 15px;
  }

  .contactpage-container {
    padding: 15px;
  }

  .second-column {
    background-size: cover;
    padding: 20px;
  }

  .form-group {
    font-size: 1rem;
  }

  .form-control {
    font-size: 16px;
  }

  .btn-primary {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .addressPage {
    height: auto;
    width: 95%;
    margin: 20px auto;
    padding: 10px;
  }

  .addresscontent {
    font-size: 16px;
    padding: 8px;
  }

  .form-group {
    font-size: 0.9rem;
  }

  .form-control {
    font-size: 14px;
  }

  .btn-primary {
    font-size: 14px;
    padding: 10px;
  }

  .animate-title {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .ContactFirst-image {
    height: auto;
  }

  .addressPage {
    height: auto;
    width: 100%;
    margin: 10px 0;
    padding: 8px;
  }

  .addresscontent {
    font-size: 14px;
    padding: 5px;
  }

  .form-group {
    font-size: 0.8rem;
  }

  .form-control {
    font-size: 12px;
  }

  .btn-primary {
    font-size: 12px;
    padding: 8px;
  }

  .animate-title {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Contact/ContactPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,kIAAkI;EAClI,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,4CAA4C;CAC7C,aAAa;EACZ,YAAY;EACZ,cAAc;;;AAGhB;;;;AAIA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;AACrB,eAAe;AACf,aAAa;AACb,4BAA4B;AAC5B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;;AAEd;AACA;EACE,cAAc;EACd,qBAAqB;;AAEvB;;;;;;;;;;AAUA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;AACA,YAAY;AACZ;AACA,iBAAiB;AACjB;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;;EAEjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Header Image Styling */\r\n.ContactFirst-image {\r\n  width: 100%;\r\n  height: auto;\r\n  animation: fadeIn 1.5s ease-in-out;\r\n}\r\n\r\n/* Container Background Styling */\r\n.contactpage-container {\r\n  background-image: url(\"https://img.freepik.com/premium-vector/light-yellow-background-with-light-orange-background_851674-48.jpg\");\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  padding: 20px;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n  font-family: 'Times New Roman', Times, serif;\r\n}\r\n\r\n.animate-title {\r\n  color: rgb(11, 16, 76);\r\n  font-size: 2rem;\r\n  font-family: 'Times New Roman', Times, serif;\r\n}\r\n\r\n.second-column {\r\n  padding: 20px;\r\n}\r\n\r\n/* Address Section */\r\n.addressPage {\r\n  background-color: rgba(246, 208, 190, 0.345);\r\n height: 570px;\r\n  width: 660px;\r\n  margin-top: 2%;\r\n\r\n\r\n}\r\n\r\n\r\n\r\n.addresscontent {\r\n  font-size: 1.2rem;\r\n  padding: 30px;\r\n  color: rgb(0, 0, 0);\r\n  font-weight: 800;\r\n  margin-top: 30px;\r\n\r\n}\r\n\r\n.contact-paratag {\r\n  margin-bottom: 10px;\r\nmax-width:250px;\r\ndisplay: flex;\r\njustify-content:space-around;\r\n}\r\n.contact-paratag a {\r\n  color: #530702; \r\n  text-decoration: none; \r\n  width: 150px;\r\n\r\n}\r\n.addresscontent a {\r\n  color: #530702; \r\n  text-decoration: none; \r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.addressinfo {\r\n  text-align: center;\r\n  color: rgb(0, 0, 0);\r\n}\r\n.form-page{\r\npadding: 5px;\r\n}\r\n/* Form Styling */\r\n.form-group {\r\n\r\n  font-size: 1rem;\r\n}\r\n\r\n.form-control {\r\n\r\n  border-radius: 8px;\r\n  margin-top: -10px;\r\n\r\n  /* padding: 10px; */\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #0e055e;\r\n  font-size: 1.1rem;\r\n  transition: background-color 0.3s ease-in-out;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #ff7b00;\r\n}\r\n\r\n/* Animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.animate-title {\r\n  animation: slideDown 1.5s ease-in-out;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1024px) {\r\n  .addressPage {\r\n    height: auto;\r\n    width: 90%;\r\n    margin: 20px auto;\r\n    padding: 15px;\r\n  }\r\n\r\n  .contactpage-container {\r\n    padding: 15px;\r\n  }\r\n\r\n  .second-column {\r\n    background-size: cover;\r\n    padding: 20px;\r\n  }\r\n\r\n  .form-group {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .form-control {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .btn-primary {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .addressPage {\r\n    height: auto;\r\n    width: 95%;\r\n    margin: 20px auto;\r\n    padding: 10px;\r\n  }\r\n\r\n  .addresscontent {\r\n    font-size: 16px;\r\n    padding: 8px;\r\n  }\r\n\r\n  .form-group {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .form-control {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .btn-primary {\r\n    font-size: 14px;\r\n    padding: 10px;\r\n  }\r\n\r\n  .animate-title {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .ContactFirst-image {\r\n    height: auto;\r\n  }\r\n\r\n  .addressPage {\r\n    height: auto;\r\n    width: 100%;\r\n    margin: 10px 0;\r\n    padding: 8px;\r\n  }\r\n\r\n  .addresscontent {\r\n    font-size: 14px;\r\n    padding: 5px;\r\n  }\r\n\r\n  .form-group {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .form-control {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .btn-primary {\r\n    font-size: 12px;\r\n    padding: 8px;\r\n  }\r\n\r\n  .animate-title {\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
